import { assertNever } from 'owa-assert';
import type { ProjectId } from 'owa-timestream-types';
import todoFolderIdMap from './todoFolderIdMap';

export default function resolveTodoFolderId(projectId: ProjectId): Promise<string> {
    const todoFolderId = todoFolderIdMap.get(projectId);
    if (!todoFolderId) {
        assertNever(`projectId: ${projectId}` as never);
    }

    if (typeof todoFolderId === 'string') {
        return Promise.resolve(todoFolderId);
    }

    return todoFolderId;
}
